// import React, { useState, useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { MdChevronRight, MdExpandMore } from "react-icons/md";
// import DashIcon from "components/icons/DashIcon";

// export function SidebarLinks(props) {
//   const location = useLocation();
//   const { routes: initialRoutes = [] } = props;

//   const [filteredRoutes, setFilteredRoutes] = useState([]);
//   const [openMenus, setOpenMenus] = useState({});
//   const [customPermission, setCustomPermission] = useState([]);
//   const [role, setRole] = useState("staff");

//   const activeRoute = (routeName) => {
//     return location.pathname.includes(routeName);
//   };

//   const toggleMenu = (path) => {
//     setOpenMenus((prev) => ({ ...prev, [path]: !prev[path] }));
//   };

//   // 1. Fetch User Data & Filter Routes on mount or when routes prop changes
//   useEffect(() => {
//     const userData = JSON.parse(localStorage.getItem("userData"));
//     const rawRoutes = Array.isArray(initialRoutes) ? initialRoutes : [];

//     if (userData) {
//       setCustomPermission(userData.permissions || []);
//       const userRole = userData.role || "staff";
//       setRole(userRole);

//       if (userRole === "masterCompany") {
//         setFilteredRoutes(rawRoutes.filter((r) => r.key !== "master"));
//       } else if (userRole === "company") {
//         // ✅ FIXED LOGIC: Must use && (AND) instead of || (OR)
//         setFilteredRoutes(
//           rawRoutes.filter((r) => r.key !== "master")
//         );
//       } else if(userRole === "exhibitor"){
//          const exhibitorRouter = ["exhibitors","products","offers"]
//          setFilteredRoutes(
//           rawRoutes.filter((r) => exhibitorRouter.includes(r.key) )
//         );
//       }

//       else {
//         setFilteredRoutes(rawRoutes);
//       }
//     } else {
//       setFilteredRoutes(rawRoutes);
//     }
//   }, [initialRoutes]);

//   // 2. Compute allowed keys set based on state permissions
//   const allowedKeys = new Set(
//     customPermission
//       .filter((p) => p.can_read || p.can_create || p.can_update || p.can_delete)
//       .map((p) => p.key)
//   );

//   // Helper function to check key permission
//   const checkKeyPermission = (key) => {
//     if (role !== "staff") return true; // Non-staff roles bypass permission key checks
//     if (!key) return true; // Routes without explicit key are visible by default
//     return allowedKeys.has(key);
//   };

//   // Check if at least one child route is allowed
//   const validateParentPermission = (parent) => {
//     if (parent.children && Array.isArray(parent.children)) {
//       return parent.children.some((child) => checkKeyPermission(child.key));
//     }
//     return false;
//   };

//   const createLinks = (routesToRender) => {
//     return routesToRender.map((route, index) => {
//       // Hide if explicitly hidden
//       if (route.hidden) return null;

//       // Layout validation
//       if (
//         !(
//           route.layout === "/admin" ||
//           route.layout === "/auth" ||
//           route.layout === "/rtl"
//         )
//       ) {
//         return null;
//       }

//       // Check single route key permission
//       if (route.key && !checkKeyPermission(route.key)) return null;

//       // Handle routes WITH CHILDREN
//       if (route.children) {
//         if (
//           role === "staff" &&
//           !validateParentPermission(route) &&
//           !checkKeyPermission(route.key)
//         ) {
//           return null;
//         }

//         // Filter valid children user is permitted to see
//         const validChildren = route.children.filter(
//           (child) => !child.hidden && checkKeyPermission(child.key)
//         );

//         if (validChildren.length === 0) return null;

//         const isExpanded =
//           openMenus[route.path] ??
//           validChildren.some((c) => activeRoute(c.path));

//         return (
//           <div key={index}>
//             <div
//               className={`relative mb-3 flex hover:cursor-pointer ${
//                 activeRoute(route.path) ? "active-nav-link" : ""
//               }`}
//               onClick={() => toggleMenu(route.path)}
//             >
//               <li className="my-[3px] flex w-full cursor-pointer items-center px-8">
//                 <span
//                   className={`${
//                     validChildren.some((c) => activeRoute(c.path))
//                       ? "active-icon"
//                       : "normal-icon"
//                   }`}
//                 >
//                   {route.icon ? route.icon : <DashIcon />}
//                 </span>
//                 <p
//                   className={`leading-1 ml-4 flex flex-1 ${
//                     validChildren.some((c) => activeRoute(c.path))
//                       ? "sidebar-text-active"
//                       : "sidebar-text-normal"
//                   }`}
//                 >
//                   {route.name}
//                 </p>
//                 <span className="ml-auto pr-4 text-gray-400">
//                   {isExpanded ? (
//                     <MdExpandMore size={18} />
//                   ) : (
//                     <MdChevronRight size={18} />
//                   )}
//                 </span>
//               </li>
//             </div>

//             {/* Submenu Dropdown */}
//             {isExpanded && (
//               <div className="mb-2 ml-6 border-l border-gray-200 dark:border-white/10">
//                 {validChildren.map((child, childIndex) => (
//                   <Link key={childIndex} to={child.layout + "/" + child.path}>
//                     <div
//                       className={`relative mb-3 flex hover:cursor-pointer ${
//                         activeRoute(child.path) ? "active-nav-link" : ""
//                       }`}
//                     >
//                       <li className="my-[3px] flex cursor-pointer items-center px-8">
//                         <span
//                           className={`${
//                             activeRoute(child.path)
//                               ? "active-icon"
//                               : "normal-icon"
//                           }`}
//                         >
//                           {child.icon ? child.icon : <DashIcon />}
//                         </span>
//                         <p
//                           className={`leading-1 ml-4 flex text-sm ${
//                             activeRoute(child.path)
//                               ? "sidebar-text-active"
//                               : "sidebar-text-normal"
//                           }`}
//                         >
//                           {child.name}
//                         </p>
//                       </li>
//                     </div>
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>
//         );
//       }

//       // Handle SINGLE routes
//       return (
//         <Link key={index} to={route.layout + "/" + route.path}>
//           <div
//             className={`relative mb-3 flex hover:cursor-pointer ${
//               activeRoute(route.path) ? "active-nav-link" : ""
//             }`}
//           >
//             <li className="my-[3px] flex cursor-pointer items-center px-8">
//               <span
//                 className={`${
//                   activeRoute(route.path) ? "active-icon" : "normal-icon"
//                 }`}
//               >
//                 {route.icon ? route.icon : <DashIcon />}
//               </span>
//               <p
//                 className={`leading-1 ml-4 flex ${
//                   activeRoute(route.path)
//                     ? "sidebar-text-active"
//                     : "sidebar-text-normal"
//                 }`}
//               >
//                 {route.name}
//               </p>
//             </li>
//           </div>
//         </Link>
//       );
//     });
//   };

//   return createLinks(filteredRoutes);
// }

// export default SidebarLinks;
import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  useCallback,
} from "react";
import ReactDOM from "react-dom";
import { Link, useLocation } from "react-router-dom";
import { MdChevronRight, MdExpandMore } from "react-icons/md";
import DashIcon from "components/icons/DashIcon";

// FIX: a default `= []` in destructuring creates a NEW array on every render,
// which re-triggers the useEffect below and can cause an infinite render loop.
const EMPTY_ROUTES = [];

export function SidebarLinks(props) {
  const location = useLocation();
  const { routes: initialRoutes = EMPTY_ROUTES, collapsed } = props;

  const [filteredRoutes, setFilteredRoutes] = useState([]);
  const [openMenus, setOpenMenus] = useState({});
  const [customPermission, setCustomPermission] = useState([]);
  const [role, setRole] = useState("staff");

  // Track hovered item and its screen position
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [popupPos, setPopupPos] = useState({ top: 0, left: 0 });

  // NEW: refs for popup measuring + delayed close (prevents flicker)
  const popupRef = useRef(null);
  const closeTimer = useRef(null);

  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const toggleMenu = (path) => {
    setOpenMenus((prev) => ({ ...prev, [path]: !prev[path] }));
  };

  /* ---------------- Collapsed popup helpers ---------------- */

  const clearCloseTimer = () => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
  };

  const closePopup = useCallback(() => {
    clearCloseTimer();
    setHoveredMenu(null);
  }, []);

  // FIX: a unique id per menu. Previously `route.path` was used, so routes with
  // no path / duplicate path opened every popup at once.
  const getMenuId = (route, index) => route.key || route.path || `menu-${index}`;

  const openPopup = (el, menuId, offset = 0) => {
    clearCloseTimer();
    const rect = el.getBoundingClientRect();
    setPopupPos({ top: rect.top + offset, left: rect.right });
    setHoveredMenu(menuId);
  };

  // When sidebar is expanded again, never leave a stale popup behind
  useEffect(() => {
    if (!collapsed) closePopup();
  }, [collapsed, closePopup]);

  // Close on route change
  useEffect(() => {
    closePopup();
  }, [location.pathname, closePopup]);

  // Cleanup timer on unmount
  useEffect(() => () => clearCloseTimer(), []);

  // Close on scroll / resize / Escape / outside click (touch devices too)
  useEffect(() => {
    if (!hoveredMenu) return;

    const onKey = (e) => e.key === "Escape" && closePopup();
    const onOutside = (e) => {
      if (popupRef.current && popupRef.current.contains(e.target)) return;
      if (e.target.closest && e.target.closest("[data-menu-id]")) return;
      closePopup();
    };

    window.addEventListener("scroll", closePopup, true); // true => catches sidebar scroll
    window.addEventListener("resize", closePopup);
    window.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onOutside);
    document.addEventListener("touchstart", onOutside);
    return () => {
      window.removeEventListener("scroll", closePopup, true);
      window.removeEventListener("resize", closePopup);
      window.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onOutside);
      document.removeEventListener("touchstart", onOutside);
    };
  }, [hoveredMenu, closePopup]);

  // FIX: keep popup inside the viewport (long submenus near bottom got cut off)
  useLayoutEffect(() => {
    const el = popupRef.current;
    if (!hoveredMenu || !el) return;
    const h = el.getBoundingClientRect().height;
    const maxTop = window.innerHeight - h - 8;
    el.style.top = `${Math.max(8, Math.min(popupPos.top, maxTop))}px`;
  }, [hoveredMenu, popupPos]);

  /* ---------------- Permissions / routes ---------------- */

  useEffect(() => {
    // FIX: JSON.parse could throw on corrupted localStorage and crash sidebar
    let userData = null;
    try {
      userData = JSON.parse(localStorage.getItem("userData"));
    } catch (err) {
      userData = null;
    }
    const rawRoutes = Array.isArray(initialRoutes) ? initialRoutes : [];

    if (userData) {
      setCustomPermission(userData.permissions || []);
      const userRole = userData.role || "staff";
      setRole(userRole);

      if (userRole === "masterCompany") {
        setFilteredRoutes(rawRoutes.filter((r) => r.key !== "master"));
      } else if (userRole === "exhibitor") {
        const exhibitorRouter = ["exhibitors", "products", "offers"];
        setFilteredRoutes(
          rawRoutes.filter((r) => exhibitorRouter.includes(r.key))
        );
      } else if (userRole === "company") {
        const companyAllowedKeys = [
          "organizers",
          "visitors",
          "program",
          "speaker",
          "bulk-notification",
          "settings",
          // "master",
          "dashboard",
        ];

        const companySubmenuKeys = [
          "currency",
          "coupan",
          "banner",
          "product-category",
          "event-category",
          "pavilion",
          "exhibitor-category",
        ];

        const filtered = rawRoutes
          .filter((r) => companyAllowedKeys.includes(r.key))
          .map((route) => {
            if (route.children && Array.isArray(route.children)) {
              return {
                ...route,
                children: route.children.filter(
                  (child) =>
                    companySubmenuKeys.includes(child.key) ||
                    companySubmenuKeys.includes(child.path)
                ),
              };
            }
            return route;
          });

        setFilteredRoutes(filtered);
      } else {
        setFilteredRoutes(rawRoutes);
      }
    } else {
      setFilteredRoutes(rawRoutes);
    }
  }, [initialRoutes]);

  const allowedKeys = new Set(
    customPermission
      .filter((p) => p.can_read || p.can_create || p.can_update || p.can_delete)
      .map((p) => p.key)
  );

  const checkKeyPermission = (key) => {
    if (role !== "staff") return true;
    if (!key) return true;
    return allowedKeys.has(key);
  };

  const validateParentPermission = (parent) => {
    if (parent.children && Array.isArray(parent.children)) {
      return parent.children.some((child) => checkKeyPermission(child.key));
    }
    return false;
  };

  /* ---------------- Mouse handlers ---------------- */

  const handleMouseEnter = (e, menuId, offset = 0) => {
    if (!collapsed) return;
    openPopup(e.currentTarget, menuId, offset);
  };

  // FIX: small delay so moving mouse from icon -> popup never flickers/closes
  const handleMouseLeave = () => {
    if (!collapsed) return;
    clearCloseTimer();
    closeTimer.current = setTimeout(() => setHoveredMenu(null), 120);
  };

  const keepPopupOpen = (menuId) => {
    clearCloseTimer();
    setHoveredMenu(menuId);
  };

  const createLinks = (routesToRender) => {
    return routesToRender.map((route, index) => {
      if (route.hidden) return null;

      if (
        !(
          route.layout === "/admin" ||
          route.layout === "/auth" ||
          route.layout === "/rtl"
        )
      ) {
        return null;
      }

      if (route.key && !checkKeyPermission(route.key)) return null;

      const menuId = getMenuId(route, index);

      // Handle Submenus
      if (route.children) {
        if (
          role === "staff" &&
          !validateParentPermission(route) &&
          !checkKeyPermission(route.key)
        ) {
          return null;
        }

        const validChildren = route.children.filter(
          (child) => !child.hidden && checkKeyPermission(child.key)
        );

        if (validChildren.length === 0) return null;

        const isExpanded =
          openMenus[route.path] ??
          validChildren.some((c) => activeRoute(c.path));

        return (
          <div
            key={index}
            data-menu-id={menuId}
            className="relative"
            onMouseEnter={(e) => handleMouseEnter(e, menuId)}
            onMouseLeave={handleMouseLeave}
          >
            <div
              className={`relative flex cursor-pointer items-center rounded-xl px-3 py-2.5 transition-all ${
                activeRoute(route.path) ||
                validChildren.some((c) => activeRoute(c.path))
                  ? "bg-[var(--color-primary)] text-white"
                  : "text-[#1a1a1a] hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/5"
              }`}
              // FIX: in collapsed mode, click toggles the popup (touch/keyboard
              // friendly) instead of toggling a hidden accordion state.
              onClick={(e) => {
                if (collapsed) {
                  if (hoveredMenu === menuId) closePopup();
                  else openPopup(e.currentTarget.parentElement, menuId);
                } else {
                  toggleMenu(route.path);
                }
              }}
            >
              <span className="text-lg">
                {route.icon ? route.icon : <DashIcon />}
              </span>
              {!collapsed && (
                <>
                  <p className="ml-3 flex-1 text-[14px] font-semibold">
                    {route.name}
                  </p>
                  <span className="text-gray-400">
                    {isExpanded ? (
                      <MdExpandMore size={16} />
                    ) : (
                      <MdChevronRight size={16} />
                    )}
                  </span>
                </>
              )}
            </div>

            {/* Submenu Links (Normal Expanded Mode) */}
            {isExpanded && !collapsed && (
              <div className="my-1 ml-4 flex flex-col gap-1 border-l border-gray-200 pl-2 dark:border-white/10">
                {validChildren.map((child, childIndex) => (
                  <Link
                    key={childIndex}
                    to={child.layout + "/" + child.path}
                    className={`flex items-center rounded-lg px-2.5 py-2 text-[14px] font-medium transition-all ${
                      activeRoute(child.path)
                        ? "bg-[var(--color-primary)] text-white"
                        : "text-[#1a1a1a] hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-white"
                    }`}
                  >
                    <span>{child.name}</span>
                  </Link>
                ))}
              </div>
            )}

            {/* Submenu Floating Portal (Collapsed Mode - Never gets clipped) */}
            {collapsed &&
              hoveredMenu === menuId &&
              ReactDOM.createPortal(
                <div
                  ref={popupRef}
                  style={{
                    position: "fixed",
                    top: popupPos.top,
                    left: popupPos.left,
                  }}
                  className="z-[99999] -ml-1 pl-2"
                  onMouseEnter={() => keepPopupOpen(menuId)}
                  onMouseLeave={handleMouseLeave}
                >
                  {/* FIX: max height + scroll so long submenus never overflow screen */}
                  <div className="max-h-[calc(100vh-16px)] w-52 overflow-y-auto rounded-xl border border-gray-100 bg-white p-2 shadow-2xl dark:border-white/10 dark:bg-navy-800">
                    <div className="border-b pb-1.5 mb-1.5 px-2 text-xs font-bold text-gray-500 uppercase tracking-wider">
                      {route.name}
                    </div>
                    <div className="flex flex-col gap-1">
                      {validChildren.map((child, childIndex) => (
                        <Link
                          key={childIndex}
                          to={child.layout + "/" + child.path}
                          onClick={closePopup}
                          className={`flex items-center rounded-lg px-3 py-2 text-[13px] font-medium transition-all ${
                            activeRoute(child.path)
                              ? "bg-[var(--color-primary)] text-white"
                              : "text-[#1a1a1a] hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/5"
                          }`}
                        >
                          <span>{child.name}</span>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>,
                document.body
              )}
          </div>
        );
      }

      // Handle Standard Single Link
      const isActive = activeRoute(route.path);

      return (
        <div
          key={index}
          data-menu-id={menuId}
          className="relative"
          onMouseEnter={(e) => handleMouseEnter(e, menuId, 6)}
          onMouseLeave={handleMouseLeave}
        >
          <Link to={route.layout + "/" + route.path} onClick={closePopup}>
            <div
              className={`relative flex items-center rounded-xl px-3 py-2.5 transition-all ${
                isActive
                  ? "bg-[var(--color-primary)] text-white"
                  : "text-[#1a1a1a] hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/5"
              }`}
            >
              <span className="text-lg">
                {route.icon ? route.icon : <DashIcon />}
              </span>
              {!collapsed && (
                <p className="ml-3 text-[14px] font-semibold">{route.name}</p>
              )}
            </div>
          </Link>

          {/* Single Link Name Tooltip Portal */}
          {collapsed &&
            hoveredMenu === menuId &&
            ReactDOM.createPortal(
              <div
                ref={popupRef}
                style={{
                  position: "fixed",
                  top: popupPos.top,
                  left: popupPos.left,
                }}
                className="z-[99999] -ml-1 pl-2 whitespace-nowrap"
                onMouseEnter={() => keepPopupOpen(menuId)}
                onMouseLeave={handleMouseLeave}
              >
                <div className="rounded-md bg-gray-900 px-3 py-1.5 text-xs font-semibold text-white shadow-md">
                  {route.name}
                </div>
              </div>,
              document.body
            )}
        </div>
      );
    });
  };

  return createLinks(filteredRoutes);
}

export default SidebarLinks;
